import { render, staticRenderFns } from "./DateTabAll.vue?vue&type=template&id=fba5685c&scoped=true"
import script from "./DateTabAll.vue?vue&type=script&lang=js"
export * from "./DateTabAll.vue?vue&type=script&lang=js"
import style0 from "./DateTabAll.vue?vue&type=style&index=0&id=fba5685c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba5685c",
  null
  
)

export default component.exports